module.exports = __webpack_public_path__ + "img/type-motorbike.18e37a6c.svg";